import React from "react";

const LOGO = "https://customer-assets-wrfwihn1.emergentagent.net/job_winter-signup/artifacts/abzb36ir_Shoreline%20RV.png";
const SCRIPT = "https://customer-assets-wrfwihn1.emergentagent.net/job_winter-signup/artifacts/p7ejy5va_ShorelineScript.png";

export default function Brand({ light = false, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src={LOGO}
        alt="Shoreline RV logo"
        className={`h-11 w-11 rounded-full object-cover ${light ? "ring-2 ring-white/70" : ""}`}
      />
      <div className="leading-tight">
        <img
          src={SCRIPT}
          alt="Shoreline RV"
          className={`h-6 w-auto object-contain ${light ? "brightness-0 invert" : ""}`}
        />
        <div className={`font-mono-label text-[9px] ${light ? "text-white/80" : "text-muted-foreground"}`}>
          Winterizing Portal
        </div>
      </div>
    </div>
  );
}
